// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {"hash":"ede9158289dc91b7e9cb9f3437f81e8df6b6b097"};
/* tslint:enable */
